export enum EntityType {
  Post = 'post',
  Poll = 'poll',
  Panel = 'panel',
  PostComment = 'post_comment',
  PollComment = 'poll_comment',
  PanelComment = 'panel_comment',
  Series = 'series',
  Chapter = 'chapter'
}

export enum EntityExtendedType {
  Post = 'post',
  Poll = 'poll',
  Panel = 'panel',
  PostComment = 'post_comment',
  PollComment = 'poll_comment',
  PanelComment = 'panel_comment'
}